import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftPersonNaturalProps } from './props';
import { SarlaftPersonNatural } from '../../../../../../shared/types/modules/sarlaft';
import {
    asyncGetParam,
    asyncGetParams,
} from '../../../../../../services/param.service';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { asyncGetCities } from '../../../../../../services/location.service';
import { formatParams } from '../../../../../../shared/utils/params';

export const useSarlaftPersonNatural = ({
    ageClient,
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftPersonNaturalProps) => {
    const [typesClients, setTypesClients] = useState<ISelect[]>([]);
    const [typeClient, setTypeClient] = useState<ISelect>();
    const [cities, setCities] = useState<ISelect[]>([]);

    const isSalaried = `${ParamEnum.TYPE_CLIENT}_1` === typeClient?.code;

    const onSubmit = (data: SarlaftPersonNatural) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(isSalaried),
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('insuredCode', data?.insuredCode || '');
        formik?.setFieldValue('age', ageClient || data?.age);
        formik?.setFieldValue('typeClient', data?.typeClient || '');
        formik?.setFieldValue('ciiu', data?.ciiu || '');
        formik?.setFieldValue('placeIssue', data?.placeIssue || '');
        formik?.setFieldValue('dateIssue', data?.dateIssue || '');
        formik?.setFieldValue('placeBirth', data?.placeBirth || '');
        formik?.setFieldValue('dateBirth', data?.dateBirth || '');
        formik?.setFieldValue('nationality', data?.nationality || '');
        formik?.setFieldValue('occupation', data?.occupation || '');
        formik?.setFieldValue('profession', data?.profession || '');
        formik?.setFieldValue('company', data?.company || '');
        formik?.setFieldValue('area', data?.area || '');
        formik?.setFieldValue('charge', data?.charge || '');
        formik?.setFieldValue('adress', data?.adress || '');
        formik?.setFieldValue('location', data?.location || '');
        formik?.setFieldValue('faxCompany', data?.faxCompany || '');
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.TYPE_CLIENT).then((items) =>
            setTypesClients(items)
        );
        asyncGetCities().then((cities) => setCities(formatParams(cities)));
    }, []);

    useEffect(() => {
        if (formik.values.typeClient) {
            asyncGetParam(formik.values.typeClient).then((res: any) =>
                setTypeClient(res?.items)
            );
        }
    }, [formik.values.typeClient]);

    return {
        formik,
        typesClients,
        cities,
        isSalaried,
    };
};
